import { rwd, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { FileUpload as FileUploadComponent } from '../../../../components-deprecated/FileUpload'
import * as FileThumbnailStyled from '../../../../components-deprecated/FileUpload/elements/FileThumbnail/styles'
import * as FileUploadStyled from '../../../../components-deprecated/FileUpload/styles'

export const TextWrapper = styled.span`
  margin-right: 20px;

  ${rwd.equalOrLessThan('xlarge')} {
    font-size: 13px;
  }
`

export const EmailLink = styled.a`
  color: inherit;
  white-space: nowrap;
`

export const FileUpload = styled(FileUploadComponent)`
  ${() => FileUploadStyled.FileListScrollableArea} {
    padding: 10px 20px;
  }

  ${() => FileUploadStyled.CloseButton} {
    margin-right: 30px;
  }

  ${() => FileThumbnailStyled.FileThumbnailContainer} {
    margin-right: 30px;
    margin-left: 20px;
  }
`

export const SectionMessageWrapper = styled.div`
  margin-top: ${Spacing.S12};
`
